import store from '@/store';
import router from '@/router'
import { Notification } from 'element-ui';
// const JsSIP = require('./jssip@3.0.23.js');

const constraints = {audio: true, video: false};
const extraHeaders = ['X-Foo: foo', 'X-Bar: bar'];
const eventHandlers = {
    'progress': function (e) {
		store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
			msg: `eventHandlers_progress`, 
			data: {
				e: e?.response?.data
			}
		});
    },
    'failed': function (e) {
		store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
			msg: `eventHandlers_failed`, 
			data: {
				e: e?.response?.data
			}
		});
    },
    'ended': function (e) {
		store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
			msg: `eventHandlers_ended`, 
			data: {
				e: e?.response?.data
			}
		});
    },
    'confirmed': function (e) {
		store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
			msg: `eventHandlers_confirmed`, 
			data: {
				e: e?.response?.data
			}
		});
    },
    'requestSucceeded': function (e) {
		sipInit()._terminate();
		store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
			msg: `requestSucceeded`, 
			data: {
				e:  e?.response?.data
			}
		});
    }
};

let telObj = {
	direction: '',
	isAnswer: false,
	phone: ''
};
let instanceNotification = null;
let outgoingSession = null;
let incomingSession = null;
let currentSession = null;
let userAgent = null;
let timer = null;
let ringMusic;
let remoteAudio;
let localAudio;
let remoteStream = null;
let receivers = null;
let cdnUrl = process.env.VUE_APP_BASE_CDN;

function isTalkPage() {
	let path = router.currentRoute.fullPath;
	return !(path != '/tel/index')
}

function CreateNotification() {
	if (!window.Notification) {
		return false;
	}
	if (window.Notification.permission === 'granted') {
		NotificationSend();
	} else if (window.Notification.permission === 'default') {
		window.Notification.requestPermission().then(permission => {
			if (permission === 'granted') {
				NotificationSend();
			} else if (permission === 'default') {
				store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
					msg: `用户关闭授权 未刷新页面之前 可以再次请求授权`, 
					data: {}
				});
			} else {
				store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
					msg: `用户拒绝授权 不能显示通知`, 
					data: {}
				});
			}
		});
	} else {
		store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
			msg: `用户曾经拒绝显示通知`, 
			data: {}
		});
	}

	function NotificationSend() {
		instanceNotification = new Notification("您有1个新的来电，请接听处理！", { "icon": `${cdnUrl}/static/images/logo.png`, "body": "快点击处理吧!" });
		instanceNotification.onshow = function () {
			store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
				msg: `NotificationSend显示通知`, 
				data: {}
			});
		};
		instanceNotification.onclick = function () {
			store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
				msg: `NotificationSend点击`, 
				data: {}
			});
			window.focus();
			setTimeout(() => {
				sipInit()._answer();
			}, 800);
			instanceNotification.close();
		};
		instanceNotification.onclose = function () {
			store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
				msg: `NotificationSend通知关闭`, 
				data: {}
			});
		};
		instanceNotification.onerror = function () {
			store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
				msg: `NotificationSend错误`, 
				data: {}
			});
		};
	}
}

export const sipInit = () => {
	function _init(category) {
		return new Promise((resolve, reject) => {
			ringMusic = document.getElementById('ringMusic');
			remoteAudio = document.getElementById('remoteAudio');
			remoteAudio.setAttribute('autoplay', '');
			remoteAudio.setAttribute('playsinline', '');
			localAudio = document.getElementById('localAudio');
			localAudio.setAttribute('autoplay', '');
			localAudio.setAttribute('playsinline', '');

			const wssPath = (['1', '2'].includes(store.getters?.StoreAgentInfo?.isPublic) && category === '外网签入') ? store.getters?.StoreAgentInfo?.sipWssPublicUrl : store.getters?.StoreAgentInfo?.sipWssIntranetUrl;
			const socket = new JsSIP.WebSocketInterface(`wss://${wssPath}`);
			const configuration = {
				sockets : [ socket ],
				outbound_proxy_set: `wss://${wssPath}`,
				uri: `sip:${store.getters?.StoreAgentInfo?.sipCode}@${store.getters?.StoreAgentInfo?.domain}`,
				password: store.getters?.StoreAgentInfo?.sipPassword,
				register: true,
				session_timers: false,
				realm: store.getters?.StoreAgentInfo?.domain,
				authorization_user: store.getters?.StoreAgentInfo?.sipCode,
				registrar_server: `sip:${wssPath.toString().substring(0, wssPath.indexOf(":"))}`,
				register_expires: 120
			};
			userAgent = new JsSIP.UA(configuration);

			// ! 注册
			userAgent.on('registered', function (data) {
				resolve();
				store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
					msg: `JS-SIP注册成功`, 
					data: {
						// data: data
					}
				});
			});

			// ! 由于注册失败而被解雇
			userAgent.on('registrationFailed', function (data) {
				store.commit('telService/SET_SOFT_PHONE_IN_MSG', `JS-SIP注册失败`);
				reject()
				store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
					msg: `JS-SIP注册失败`, 
					data: {
						// data: data
					}
				});
			});

			// ! 在注册期间发射几秒钟，如果应用程序没有为这个事件设置任何监听器，JsSIP将像往常一样重新注册。
			userAgent.on('registrationExpiring', function () {
				store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
					msg: `JS-SIP重新注册`, 
				});
				userAgent.register();
			});

			// ! 退出
			userAgent.on('unregistered', function (data) {
				store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
					msg: `JS-SIP退出`, 
					data: {
						// data: data
					}
				});
				window.clearInterval(timer);
			});

			// ! 网络 / 会议
			userAgent.on('newRTCSession', function (data) {
				store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
					msg: `newRTCSession`, 
					data: {
						originator: data?.originator
					}
				});
				if (data.originator === 'remote') {
					incomingSession = data.session;
					store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
						msg: `调用进线：ibEvent`, 
						data: {}
					});
					ibEvent(data);
				} else {
					outgoingSession = data.session;
					outgoingSession.on('connecting', function(data) {
						store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
							msg: `connecting`, 
							data: {}
							// data: {
							// 	data: data
							// }
						});
						currentSession = outgoingSession;
						outgoingSession = null;
					});
					store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
						msg: `OB 外呼`, 
						data: {}
						// data: {
						// 	data: data
						// }
					});
				}
				data.session.on('accepted', function(data) {
					store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
						msg: `accepted`, 
						data: {}
						// data: {
						// 	data: data
						// }
					});
					if (data.originator == 'remote' && currentSession == null) {
						currentSession = incomingSession;
						incomingSession = null;
					}
					
					receivers = currentSession?.connection?.getReceivers();
					if(receivers) {
						remoteStream = new window.MediaStream();
						receivers.forEach(function (receiver) {
							let track = receiver.track;
							if(track) {
								remoteStream.addTrack(track);
							}
						});
					} else {
						remoteStream = currentSession?.connection?.getRemoteStreams()?.[0];
					}
					localAudio.srcObject = remoteStream;
					localAudio.play();
				});

				data.session.on('confirmed', function(data) {
					store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
						msg: `confirmed`, 
						data: {}
						// data: {
						// 	data: data
						// }
					});
					telObj.isAnswer = true;
					if (data.originator == 'remote' && currentSession == null) {
						currentSession = incomingSession;
						incomingSession = null;
					}
					// localAudio.srcObject = currentSession.connection.getLocalStreams()[0];
					// const receivers = currentSession.connection?.getReceivers();
					// if (receivers) receivers.forEach((receiver) => stream.addTrack(receiver.track));
					// localAudio.srcObject = stream;
					// localAudio.play();

					stopRing();
					store.commit('telService/SET_CALL_TIME', '00:00:00');
					setTimer();
					store.commit('telService/SET_IS_CALL', true);
					store.commit('telService/SET_IS_ANSWER', true);
					store.commit('telService/SET_IS_KEEP', false);
					if([false, 'false', null].includes(store.getters.StoreIsMonitor)) {
						if(store.getters?.StoreIsIdle) {
							ReviseCallContactInfo({
								brand: store.getters?.userInfo.brandIdentify,
								histId: store.getters?.StoreIsCallCurrentInfo?.histId, 
								type: 1
							});
						}
						ReviseIncidentUpdIncidentOrder({
							brandId: store.getters?.userInfo.brandIdentify,
							tuid: store.getters?.StoreIsCallCurrentInfo.incidentId,
							answerTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
						});
					}
				});

				data.session.on('progress', function(data) {
					store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
						msg: `onProgress`, 
						data: {}
						// data: {
						// 	data: data
						// }
					});
				});

				data.session.on('peerconnection', function(data) {
					store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
						msg: `peerconnection`, 
						data: {}
						// data: {
						// 	data: data
						// }
					});
					data.peerconnection.onaddstream = function (ev) {
						remoteAudio.srcObject = ev.stream;
						remoteAudio.play();
					};
					// data.peerconnection.addEventListener('addstream', function (e) {
					// 	// set remote audio stream
					// 	// const remoteAudio = document.createElement('audio');
					// 	remoteAudio.src = window.URL.createObjectURL(e.stream);
					// 	remoteAudio.play();
					// });
					// const stream = new MediaStream();
					// const receivers = data.session.connection?.getReceivers();
					// if (receivers) receivers.forEach((receiver) => stream.addTrack(receiver.track));
					// remoteAudio.srcObject = stream;
					// // 最后都要播放
					
				});

				data.session.on('failed', function (data) {
					localStorage.removeItem('IframePageOB');
					store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
						msg: `failed`, 
						data: {}
						// data: {
						// 	data: data
						// }
					});
					telObj = {
						direction: '',
						isAnswer: false,
						phone: ''
					}
					store.commit('telService/SET_CALLOUT', false);
					// store.commit('telService/SET_TU_ID', '');
					if([false, 'false', null].includes(store.getters.StoreIsMonitor)) {
						if(store.getters?.StoreIsIdle) {
							ReviseCallContactInfo({
								brand: store.getters?.userInfo.brandIdentify,
								histId: store.getters?.StoreIsCallCurrentInfo?.histId, 
								type: 3,
								endTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
							});
						}
						// if(!store.getters.StoreIsBusyReasonList.includes(store.getters.StoreIsBusyReason)) {
						// 	ReviseCallSetBusy();
						// }
						setTimeout(() => {
							store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
								msg: `获取坐席当前状态接口参数`, 
								data: {
									data: {
										projectCode: store.getters?.userInfo?.brandIdentify,
										agentCode: store.getters?.userInfo?.agentCode
									}
								}
							});
							Vue.prototype.$api.apiGetAgentStatus({
								projectCode: store.getters?.userInfo?.brandIdentify,
								agentCode: store.getters?.userInfo?.agentCode
							}).then(res => {
								if(res.errcode != 0) {
									store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
										msg: ` 状态查询接口失败`, 
										data: {
											errmsg: res?.errmsg
										}
									});
									return;
								};
								store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
									msg: ` 状态查询接口成功`, 
									data: {
										data: res?.data
									}
								});
								if(res.data?.[0]?.['state'] === '置闲') {
									store.commit('telService/SET_IS_IDLE' ,true);
									store.commit('telService/SET_IS_BUSY', {
										StoreIsBusy: false, 
										StoreIsBusyReason: `置闲`
									});
								} else if(res.data?.[0]?.['state'] === '置忙') {
									store.commit('telService/SET_IS_BUSY', {
										StoreIsBusy: true, 
										StoreIsBusyReason: res.data?.[0]?.['aux']
									});
									store.commit('telService/SET_IS_IDLE', false);
								} else if(res.data?.[0]?.['state'] === '后处理') {
									store.commit('telService/SET_IS_BUSY', {
										StoreIsBusy: true, 
										StoreIsBusyReason: `后处理`
									});
									store.commit('telService/SET_IS_IDLE', true);
								} else if(res.data?.[0]?.['state'] === '来电振铃中') {
									store.commit('telService/SET_IS_ANSWER' ,false);
									store.commit('telService/SET_IS_CALL' ,true);
									store.commit('telService/SET_IS_MONITOR' ,false);
									store.commit('telService/SET_IS_BUSY', {
										StoreIsBusy: false, 
										StoreIsBusyReason: `置闲`
									});
									store.commit('telService/SET_IS_IDLE' ,true);
								}

							});
						}, 500);
					}
					sipInit()._terminate();
				});

				data.session.on('ended', function (data) {
					localStorage.removeItem('IframePageOB');
					store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
						msg: ` ended`, 
						data: {}
						// data: {
						// 	data: data
						// }
					});
					store.commit('telService/SET_CALLOUT', false);
					// store.commit('telService/SET_TU_ID', '');
					if([false, 'false', null].includes(store.getters.StoreIsMonitor)) {
						if(store.getters?.StoreIsIdle) {
							ReviseCallContactInfo({
								brand: store.getters?.userInfo.brandIdentify,
								histId: store.getters?.StoreIsCallCurrentInfo?.histId, 
								type: 2, 
								callDuration: store.getters?.StoreCallTime
							});
						}
						ReviseIncidentUpdIncidentOrder({
							brandId: store.getters?.userInfo.brandIdentify,
							tuid: store.getters?.StoreIsCallCurrentInfo.incidentId,
							endTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
						});
						// if(!store.getters.StoreIsBusyReasonList.includes(store.getters.StoreIsBusyReason)) {
						// 	ReviseCallSetBusy();
						// }
						setTimeout(() => {
							store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
								msg: `获取坐席当前状态接口参数`, 
								data: {
									data: {
										projectCode: store.getters?.userInfo?.brandIdentify,
										agentCode: store.getters?.userInfo?.agentCode
									}
								}
							});
							Vue.prototype.$api.apiGetAgentStatus({
								projectCode: store.getters?.userInfo?.brandIdentify,
								agentCode: store.getters?.userInfo?.agentCode
							}).then(res => {
								if(res.errcode != 0) {
									store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
										msg: ` 状态查询接口失败`, 
										data: {
											errmsg: res?.errmsg
										}
									});
									return;
								};
								store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
									msg: ` 状态查询接口成功`, 
									data: {
										data: res?.data
									}
								});
								if(res.data?.[0]?.['state'] === '置闲') {
									store.commit('telService/SET_IS_IDLE' ,true);
									store.commit('telService/SET_IS_BUSY', {
										StoreIsBusy: false, 
										StoreIsBusyReason: `置闲`
									});
								} else if(res.data?.[0]?.['state'] === '置忙') {
									store.commit('telService/SET_IS_BUSY', {
										StoreIsBusy: true, 
										StoreIsBusyReason: res.data?.[0]?.['aux']
									});
									store.commit('telService/SET_IS_IDLE', false);
								} else if(res.data?.[0]?.['state'] === '后处理') {
									store.commit('telService/SET_IS_BUSY', {
										StoreIsBusy: true, 
										StoreIsBusyReason: `后处理`
									});
									store.commit('telService/SET_IS_IDLE', true);
								} else if(res.data?.[0]?.['state'] === '来电振铃中') {
									store.commit('telService/SET_IS_ANSWER' ,false);
									store.commit('telService/SET_IS_CALL' ,true);
									store.commit('telService/SET_IS_MONITOR' ,false);
									store.commit('telService/SET_IS_BUSY', {
										StoreIsBusy: false, 
										StoreIsBusyReason: `置闲`
									});
									store.commit('telService/SET_IS_IDLE' ,true);
								}
							});
						}, 500);
					}
					if(data.originator === 'remote') {
						sipInit()._terminate();
					}
					store.commit('telService/SET_IS_MONITOR', false);
					automaticSendSms();
				});

				data.session.on('hold', function (data) {
					store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
						msg: `保持`, 
						data: {}
						// data: {
						// 	data: data
						// }
					});
				});
				data.session.on('unhold', function (data) {
					store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
						msg: `恢复`, 
						data: {}
						// data: {
						// 	data: data
						// }
					});
				});
				data.session.on('muted', function (data) {
					store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
						msg: ` 静音`, 
						data: {}
						// data: {
						// 	data: data
						// }
					});
				});
				data.session.on('unmuted', function (data) {
					store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
						msg: ` 取消静音`, 
						data: {}
						// data: {
						// 	data: data
						// }
					});
				});
				data.session.on('refer', function (data) {
					store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
						msg: ` 转接`, 
						data: {}
						// data: {
						// 	data: data
						// }
					});
				});
			});

			// ! 开始
			userAgent.start();
		});
	}

	// ! 拨打电话
	function _call(phone, data, type, sourceType) {
		store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
			msg: ` 拨打电话`, 
			data: {
				data: {phone: phone, data: data, type: type, sourceType: sourceType}
			}
		});
		const options = {
			'extraHeaders': extraHeaders,
			'eventHandlers': eventHandlers,
			'mediaConstraints': constraints,
		};
		if (type === "*5") {
			// // Vue.prototype.$api.apiPostSelectForeign({
			// // 	landlineNumber: store.getters?.StoreAgentInfo.calleridText,
			// // 	phoneNumber: phone
			// // }).then(response => {
			// 	store.commit('telService/SET_CALL_TIME', '00:00:00');
			// 	setTimer();
			// 	// if(response.errcode != 0) {
			// 	// 	phone = `${store.getters?.StoreAgentInfo.preNumber}${phone}`;
			// 	// 	return;
			// 	// }
			// 	// if(response?.data) {
			// 	// 	phone = `0${store.getters?.StoreAgentInfo.preNumber}${phone}`;
			// 	// } else {
			// 		phone = `${store.getters?.StoreAgentInfo.preNumber}${phone}`;
			// 	// }
			// 	userAgent.call(phone, options);
			// 	store.commit('telService/SET_SOFT_PHONE_IN_MSG', `调用接口：ReviseIncidentCreIncidentOrder`);
			// 	ReviseIncidentCreIncidentOrder(data);
			// // });
			if(sourceType === 'Breathe' && /^1[3456789]\d{9}$/.test(phone)) {
				Vue.prototype.$api.apiPostSelectForeign({
					landlineNumber: store.getters?.StoreAgentInfo.calleridText,
					phoneNumber: phone
				}).then(response => {
					// if(response.errcode != 0) {
					// 	phone = `${store.getters?.StoreAgentInfo.preNumber}${phone}`;
					// 	return;
					// }
					if(response?.data) {
						phone = `0${store.getters?.StoreAgentInfo.preNumber}${phone}`;
					} else {
						phone = `${store.getters?.StoreAgentInfo.preNumber}${phone}`;
					}
					store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
						msg: ` 接口判断手机号码是否外地 - 成功`, 
						data: {
							data: {phone: phone, data: response}
						}
					});
					userAgent.call(phone, options);
					store.commit('telService/SET_CALL_TIME', '00:00:00');
					setTimer();
					// store.commit('telService/SET_SOFT_PHONE_IN_MSG', `调用接口：ReviseIncidentCreIncidentOrder`);
					ReviseIncidentCreIncidentOrder(data);
				}).catch((error) => {
					phone = `${store.getters?.StoreAgentInfo.preNumber}${phone}`;
					store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
						msg: ` 接口判断手机号码是否外地 - 失败`, 
						data: {
							data: {phone: phone, data: error}
						}
					});
					userAgent.call(phone, options);
					store.commit('telService/SET_CALL_TIME', '00:00:00');
					setTimer();
					// store.commit('telService/SET_SOFT_PHONE_IN_MSG', `调用接口：ReviseIncidentCreIncidentOrder`);
					ReviseIncidentCreIncidentOrder(data);
				});
			} else {
				phone = `${store.getters?.StoreAgentInfo.preNumber}${phone}`;
				userAgent.call(phone, options);
				store.commit('telService/SET_CALL_TIME', '00:00:00');
				setTimer();
				// store.commit('telService/SET_SOFT_PHONE_IN_MSG', `调用接口：ReviseIncidentCreIncidentOrder`);
				ReviseIncidentCreIncidentOrder(data);
			}

		} else {
			store.commit('telService/SET_CALL_TIME', '00:00:00');
			setTimer();
			console.log(phone)
			userAgent.call(phone, options);
			// store.commit('telService/SET_SOFT_PHONE_IN_MSG', `调用接口：ReviseIncidentCreIncidentOrder`);
			ReviseIncidentCreIncidentOrder(data);
		}
	}

	// ! 监空
	function _monitor(phone) {
		const options = {
			'extraHeaders': extraHeaders,
			'eventHandlers': eventHandlers,
			'mediaConstraints': constraints,
		};
		store.commit('telService/SET_IS_CALL_CURRENT_INFO', Object.assign({phone: phone}));
		console.log(phone)
		outgoingSession = userAgent.call(phone, options);
	}

	// ! 接听电话
	function _answer() {
		store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
			msg: `接听电话 - _answer`, 
			data: {}
		});
		incomingSession.answer({'mediaConstraints': constraints, 'mediaStream': null});
	}

	// ! 挂断电话
	function _terminate() {
		stopRing();
		window.clearInterval(timer);
		try {
			currentSession.terminate({'status_code': 200});
		} catch (e) {
			userAgent.terminateSessions({'status_code': 200});
		}
		setTimeout(() => {
			store.commit('telService/SET_IS_IDLE', false);
		}, 500);
		store.commit('telService/SET_IS_KEEP', false);
		store.commit('telService/SET_IS_CALL', false);
		store.commit('telService/SET_IS_ANSWER', false);
		store.commit('telService/SET_IS_CALL_CURRENT_INFO', {});
		currentSession = null;
	}

	// ! 保持 / 恢复电话
	function _hold() {
		const holdStatus = currentSession.isOnHold();
		const options = {'useUpdate': false};
		holdStatus.local === true ? currentSession.unhold(options, null) : currentSession.hold(options, null);
		return true;
	}

	// ! 静音  / 恢复电话
	function _muted() {
		const mutedStatus = currentSession.isMuted();
		const options = {audio: true}
		if(mutedStatus.audio == true || mutedStatus.video == true) {
			currentSession.unmute(options, null);
			return true;
		} else { 
			currentSession.mute(options, null);
			return true;
		}
		
	}

	// ! 转接电话
	function _refer(sip_phone_number) {
		store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
			msg: ` 转接电话`, 
			data: {
				sip_phone_number: sip_phone_number
			}
		});
		const options = {
			'extraHeaders': extraHeaders,
			'eventHandlers': eventHandlers,
		};
		currentSession.refer(sip_phone_number, options);
	}

	// ! 按键
	function _sendDTMF(tones) {
		store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
			msg: `按键：${tones}`
		});
		var options = {'status_code': 200};
		var extraHeaders = ['X-Foo: foo', 'X-Bar: bar'];
		var options = {
			'duration': 160,
			'interToneGap': 1200,
			'extraHeaders': extraHeaders
		};
		currentSession.sendDTMF(tones, options);
	}

	// ! 退出
	function _stop() {
		userAgent.stop();
	}

	return {
		_init,
		_call,
		_monitor,
		_answer,
		_terminate,
		_hold,
		_muted,
		_refer,
		_sendDTMF,
		_stop
	}
}


// ! 进线
function ibEvent(data) {
	telObj.direction = 'ib';
	telObj.phone = data?.request?.from?.uri?.user;
	store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
		msg: ` IB 进线`, 
		data: {}
	});
	store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
		msg: ` IB 进线 - ev`, 
		data: {
			data: {
				originator: data?.originator,
				body: data?.request?.data,
				phone: data?.request?.from?.uri?.user,
			}
		}
	});
	setTimeout(() => {
		store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
			msg: ` 电话进线 - 调用来电信息接口`, 
			data: {agentName: store.getters?.userInfo?.agentCode}
		});
		Vue.prototype.$api.apiPostMemberCallInfo({agentName: store.getters?.userInfo?.agentCode}).then(response => {
			if(response.errcode != 0) {
				store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
					msg: ` IB 获取当前来电信息失败`, 
					data: {
						errmsg: response?.errmsg
					}
				});
				return;
			}
			store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
				msg: ` IB 获取当前来电信息成功`, 
				data: {
					data: data?.data
				}
			});
			const result = response.data;
			if (!isTalkPage()) {
				Notification({
					position: 'bottom-right',
					dangerouslyUseHTMLString: true,
					message: '<strong style="color:red;">您有1个新的来电，请接听处理</strong>'
				});
			}
		
			
			if(store.state.app.isShowTips) {
				CreateNotification();
			}
		
			// CreateNotification();
			// store.commit('telService/SET_SOFT_PHONE_IN_MSG', `调用接口：apiPostAddCallHistory`);
			store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
				msg: ` IB 创建来电记录参数化`, 
				data: {
					data: {
						brand: store.getters?.userInfo.brandIdentify,
						phoneNumber: formatMobile(result.callerid),
						calledNumber: result.initial_dest,
						extensionNumber: '',
						ucid: result.uuid,
						perUcid: store.getters?.userInfo?.agentCode,
						skill: result.queue
					}
				}
			});
			Vue.prototype.$api.apiPostAddCallHistory({
				brand: store.getters?.userInfo.brandIdentify,
				phoneNumber: formatMobile(result.callerid),
				calledNumber: result.initial_dest,
				extensionNumber: '',
				ucid: result.uuid,
				perUcid: store.getters?.userInfo?.agentCode,
				skill: result.queue
			}).then(resp => {
				if(resp.errcode != 0) {
					store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
						msg: ` IB 创建来电记录失败`, 
						data: {
							errmsg: data?.errmsg
						}
					});
					return;
				}
				store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
					msg: ` IB 创建来电记录成功`, 
					data: {
						data: data?.data
					}
				});
				// ~ phoneNumber formatMobile(result.callerid)
				// Vue.prototype.$api.apiPostQueryPhoneBelonging({segment: result.callerid.length > 11 ? result.callerid.substring(1, 8) : result.callerid.substring(0, 7)}).then(res => {
				// 	if(res.errcode != 0) {
				// 		store.commit('telService/SET_SOFT_PHONE_IN_MSG', `IB 获取来电归属地失败, ${res.errmsg}`);
				// 		return;
				// 	}
				// 	store.commit('telService/SET_SOFT_PHONE_IN_MSG', `IB 获取来电归属地, ${JSON.stringify(res.data)}`);
				// 	store.commit('telService/SET_IS_CALL_CURRENT_INFO', Object.assign(result, resp.data, res.data));
				// 	store.commit('telService/SET_IS_CALL', true);
				// 	store.commit('telService/SET_CALL_TIME', '00:00:00');
				// 	setTimer();
				// 	playRing();
				// 	// ~ prov
				// 	if(res.data?.province) {
				// 		ReviseCallContactInfo({
				// 			histId: store.getters?.StoreIsCallCurrentInfo?.histId,
				// 			brand: store.getters?.userInfo.brandIdentify,
				// 			belong: res.data?.province
				// 		});
				// 	}
				// 	router.push({path: '/tel/index'});
				// });
				if(result.callerid.length > 6 && !['imocssit', 'imocsuat', 'imocs'].includes(store.getters.userInfo.brandIdentify)) {
					// store.commit('telService/SET_SOFT_PHONE_IN_MSG', `调用接口：apiPostQueryBelonging`);
					Vue.prototype.$api.apiPostQueryBelonging({
						phoneNumber: result.callerid
					}).then(res => {
						if(res.errcode != 0) {
							store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
								msg: ` IB 获取来电归属地失败`, 
								data: {
									errmsg: data?.errmsg
								}
							});
							// return;
						} else {
							store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
								msg: ` IB 获取来电归属地成功`, 
								data: {
									data: data?.data
								}
							});
						}
						store.commit('telService/SET_IS_CALL_CURRENT_INFO', Object.assign(result, resp.data,  res?.data ?  res?.data : {}));
						store.commit('telService/SET_IS_CALL', true);
						store.commit('telService/SET_CALL_TIME', '00:00:00');
						setTimer();
						playRing();
						if(res?.data?.city) {
							// store.commit('telService/SET_SOFT_PHONE_IN_MSG', `调用接口：ReviseCallContactInfo`);
							ReviseCallContactInfo({
								histId: store.getters?.StoreIsCallCurrentInfo?.histId,
								brand: store.getters?.userInfo.brandIdentify,
								belong: res?.data?.city
							});
						}
						router.push({path: '/tel/index'});
					});
				} else {
					store.commit('telService/SET_IS_CALL_CURRENT_INFO', Object.assign(result, resp.data));
					store.commit('telService/SET_IS_CALL', true);
					store.commit('telService/SET_CALL_TIME', '00:00:00');
					setTimer();
					playRing();
					router.push({path: '/tel/index'});
				}
			});
		}).catch(error => {
			store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
				msg: ` IB 获取当前来电信息失败 - catch`, 
				data: {
					error: error
				}
			});
		});
	}, 500);
};

// ! 置忙状态修改
// function ReviseCallSetBusy() {
// 	Vue.prototype.$api.apiPostCallSetBusy({agentName: store.getters?.userInfo?.agentCode, auxCode: 2}).then(response => {
// 		if(response.errcode != 0) return;
// 		setTimeout(() => {
// 			store.commit('telService/SET_IS_BUSY', {
// 				StoreIsBusy: true, 
// 				StoreIsBusyReason: '后处理'
// 			});
// 			store.commit('telService/SET_IS_IDLE', true);
// 		}, 500);
// 	});
// };

// ! 修改来电记录
function ReviseCallContactInfo(data) {
	store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
		msg: `修改来电记录参数`, 
		data: {
			data: data
		}
	});
	Vue.prototype.$api.apiPostCallContactEdit(data).then(response => {
		if(response.errcode != 0) {
			store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
				msg: `修改来电记录失败`, 
				data: {
					errmsg: response?.errmsg
				}
			});
			return;
		}
		store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
			msg: `修改来电记录成功`, 
			data: {
				data: response?.data
			}
		});
	});
};

// ! 修改沟通记录
function ReviseIncidentUpdIncidentOrder(data) {
	store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
		msg: `修改沟通记录参数`, 
		data: {
			data: data
		}
	});
	Vue.prototype.$api.apiPostUpdateCommunicate(data).then(response => {
		if(response.errcode != 0) {
			store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
				msg: `修改沟通记录失败`, 
				data: {
					errmsg: response?.errmsg
				}
			});
			return;
		}
		store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
			msg: `修改沟通记录成功`, 
			data: {
				data: response?.data
			}
		});
	});
};

// ! 新增沟通记录
function ReviseIncidentCreIncidentOrder(data) {
	store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
		msg: `新增沟通记录参数`, 
		data: {
			data: data
		}
	});
	Vue.prototype.$api.apiPostCreateCommunicate(data).then(response => {
		if(response.errcode != 0) {
			store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
				msg: `新增沟通记录失败`, 
				data: {
					errmsg: response?.errmsg
				}
			});
			return;
		}
		store.commit('telService/SET_IS_CALL_CURRENT_INFO', Object.assign(response.data, {
			phone: data.calledNumber.length > 11 ? data.calledNumber.substring(data.calledNumber.length - 11) : data.calledNumber
		}));
		store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
			msg: `新增沟通记录成功`, 
			data: {
				data: response?.data
			}
		});
		setTimeout(() => {
			// ! 获取当前来电信息
			store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
				msg: `获取当前来电信息参数`, 
				data: {
					data: data
				}
			});
			Vue.prototype.$api.apiPostMemberCallInfo({agentName: store.getters?.userInfo?.agentCode}).then(res => {
				if(res.errcode != 0) {
					store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
						msg: `获取当前来电信息失败`, 
						data: {
							errmsg: res?.errmsg
						}
					});
					return;
				}
				store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
					msg: `获取当前来电信息成功`, 
					data: {
						data: res?.data
					}
				});
				store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
					msg: `处理当前来电信息`, 
					data: {
						data:  Object.assign(response.data, {
							phone: data.calledNumber.length > 11 ? data.calledNumber.substring(data.calledNumber.length - 11) : data.calledNumber,
						}, res.data)
					}
				});
				store.commit('telService/SET_IS_CALL_CURRENT_INFO', Object.assign(response.data, {
					phone: data.calledNumber.length > 11 ? data.calledNumber.substring(data.calledNumber.length - 11) : data.calledNumber,
				}, res.data));
				
				// ! 上传录音文件
				store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
					msg: `上传录音文件参数`, 
					data: {
						data: {
							brandId: store.getters?.userInfo.brandIdentify,
							incidentId: store.getters?.StoreIsCallCurrentInfo.incidentId,
							dataId: res.data?.uuid,
							channelId: 'phone',
							dataType: 'UCID'
						}
					}
				});
				Vue.prototype.$api.apiAddIncidentData({
					brandId: store.getters?.userInfo.brandIdentify,
					incidentId: store.getters?.StoreIsCallCurrentInfo.incidentId,
					dataId: res.data?.uuid,
					channelId: 'phone',
					dataType: 'UCID'
				}).then(resc => {
					if(resc.errcode != 0) {
						store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
							msg: `上传录音文件失败`, 
							data: {
								errmsg: resc?.errmsg
							}
						});
						return;
					}
					store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
						msg: `上传录音文件成功`, 
						data: {
							data: resc?.data
						}
					});
					store.commit('telService/SET_TU_ID', resc?.data?.tuid);
				});
			});
		}, 3000);
	});
}

// ! 停止来电铃声
function stopRing() {
	store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
		msg: `停止铃声`
	});
    ringMusic.pause();
}

// ! 播放来电铃声
function playRing() {
	store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
		msg: `播放铃声`
	});
    ringMusic.play();
}

// ! 辅助函数
function calcTiming(now, d) {
	let diff = (now - d) / 1000;
	let hours = Math.floor(diff / 3600);
	let minutes = Math.floor(diff % 3600 / 60);
	let seconds = Math.floor(diff % (3600) % 60);
	store.commit('telService/SET_CALL_TIME', `${hours > 9 ? hours :  '0' + hours}:${minutes > 9 ? minutes : '0' + minutes}:${seconds > 9 ? seconds : '0' + seconds}`);
};
function setTimer() {
	let startTime = new Date().getTime();
	window.clearInterval(timer);
	timer = setInterval(() => {
		let currentTime = new Date().getTime();
		calcTiming(currentTime, startTime);
	}, 1000);
};

function formatMobile(mobile) {
	if(mobile.length > 11) {
		const head = mobile.toString().substring(mobile.length - 12, mobile.length).substring(0, 3);
		const one = head.substring(1, 2);
		if(head == '010') {
			return mobile;
		} else {
			if(one == '1') {
				return mobile.toString().substring(mobile.length - 11);
			} else {
				return mobile;
			}
		}
	} else {
		return mobile;
	}
}

// ! 电话挂断之后自动发送短信 - 蒂芙尼
function automaticSendSms() {
	telObj.phone = telObj.phone.length > 11 ? telObj.phone.substring(telObj.phone.length - 11) : telObj.phone
	const data = {
		br: store.getters?.userInfo.brandIdentify,
		da: telObj.phone,
		sp: process.env.NODE_ENV == 'production' ? 'Tiffany' : "踢翻你测试",
		templetId: process.env.NODE_ENV == 'production' ? 'tiffany00000001' : "tiffanysit00000001",
		sm: ""
	};
	if(['tiffanysit', 'tiffany'].includes(store.getters?.userInfo?.brandIdentify) && telObj.direction === 'ib' && telObj.isAnswer && /^1[3456789]\d{9}$/.test(telObj.phone)) {
		Vue.prototype.$api.apiPostCallIbContactList({
			pageNumber: 1,
			pageSize: 1,
			showType: 2,
			startDate: '2020-09-01',
			endDate: dayjs(new Date()).format('YYYY-MM-DD'),
			ibStatus: 1,
			phoneNumber: telObj.phone
		}).then(res => {
			store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
				msg: `查询来电记录接口响应数据`, 
				data: {
					data: res
				}
			});
			if(res.errcode != 0) {
				telObj = {
					direction: '',
					isAnswer: false,
					phone: ''
				}
			};
			if(res?.total < 2) {
				store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
					msg: `自动发送短信参数`, 
					data: {
						data: data
					}
				});
				Vue.prototype.$api.apiPostAutomaticSendSms(data).then(response => {
					store.commit('telService/SET_SOFT_PHONE_IN_MSG', {
						msg: `自动发送短信接口响应数据`, 
						data: {
							data: response
						}
					});
					telObj = {
						direction: '',
						isAnswer: false,
						phone: ''
					}
				});
			} else {
				telObj = {
					direction: '',
					isAnswer: false,
					phone: ''
				}
			}
		});
	} else {
		telObj = {
			direction: '',
			isAnswer: false,
			phone: ''
		}
	}
}